/** @format */

import React from 'react'
import { AutoComplete } from 'antd'
import './style.css'



export default function CustomAutoComplete(props) {
	return (
		<AutoComplete {...props}/>
	)
}
